module.exports = __webpack_public_path__ + "static/download_bg-9dcde6f297bb3f18e05c26a0bb756056.jpg";